<!-- Ergebnis eines Testlaufs (Figma 16343:102008, Frame 04). Überschrift „Ergebnis-Preview" und
     „Wird nicht gespeichert" gehören zum Popup, nicht hierher. -->
<div class="flex flex-col gap-3 w-full">

  <!-- Meta: Gesamtstatus + Uhrzeit · Dauer · Modell · Stand -->
  <div class="flex flex-wrap items-center gap-2 min-w-0">
    <bic-badge [type]="badgeType" data-testid="rule-test-status">
      <fa-icon iconLeft [icon]="statusIcon"></fa-icon>
      {{ statusLabel }}
    </bic-badge>
    <span class="text-xs text-gray-500 min-w-0 truncate">{{ metaText }}</span>
  </div>

  <!-- Result-Card wie im Bericht -->
  @if (hasResult) {
    <div class="flex flex-col w-full">
      <app-report-card-view
        (toggleItem)="toggleCard($event)"
        [expandedKeys]="expandedKeys"
        [model]="cardModel">
      </app-report-card-view>
    </div>
  } @else {
    <div class="flex items-center justify-center rounded-lg border border-dashed border-gray-300 py-8 px-4"
         data-testid="rule-test-empty">
      <app-empty-state
        [icon]="faFileCircleQuestion"
        [message]="emptyMessage">
      </app-empty-state>
    </div>
  }

  <!-- Hybrid: Ablauf je Modul -->
  @if (traceGroups.length > 0) {
    <div class="rounded-lg border border-gray-200 w-full" data-testid="rule-test-trace">
      <button (click)="traceOpen = !traceOpen"
              [attr.aria-expanded]="traceOpen"
              class="flex w-full items-center justify-between gap-2 px-4 py-3 text-left text-sm font-medium text-gray-900"
              type="button">
        <span>Ablauf je Modul</span>
        <fa-icon [icon]="traceOpen ? faChevronUp : faChevronDown" class="text-gray-500"></fa-icon>
      </button>

      @if (traceOpen) {
        <div class="flex flex-col gap-3 border-t border-gray-200 px-4 py-3">
          @for (group of traceGroups; track group.key) {
            <div class="flex flex-col gap-1">
              @if (group.element) {
                <span class="text-xs font-medium text-gray-500">{{ group.element }}</span>
              }
              @for (row of group.rows; track row.key) {
                <div class="flex flex-col rounded-md bg-gray-50">
                  <button (click)="toggleTraceRow(row.key)"
                          [attr.aria-expanded]="expandedTraceRows.has(row.key)"
                          class="flex w-full items-center gap-2 px-3 py-2 text-left text-sm"
                          type="button">
                    <fa-icon [class]="traceStatusColor(row.status)" [icon]="traceStatusIcon(row.status)"></fa-icon>
                    <span class="font-medium text-gray-900 truncate">{{ row.label }}</span>
                    @if (row.branch) {
                      <span class="text-xs text-gray-500 truncate">→ {{ row.branch }}</span>
                    }
                    <fa-icon [icon]="expandedTraceRows.has(row.key) ? faChevronUp : faChevronDown"
                             class="ml-auto text-gray-400"></fa-icon>
                  </button>
                  @if (expandedTraceRows.has(row.key)) {
                    <div class="flex flex-col gap-2 px-3 pb-3">
                      <div class="flex flex-col gap-1">
                        <span class="text-xs font-medium text-gray-500">Eingabe</span>
                        <pre class="max-h-48 overflow-auto rounded bg-white p-2 font-mono text-xs text-gray-700 whitespace-pre-wrap break-all">{{ row.inputJson ?? '–' }}</pre>
                      </div>
                      <div class="flex flex-col gap-1">
                        <span class="text-xs font-medium text-gray-500">Ausgabe</span>
                        <pre class="max-h-48 overflow-auto rounded bg-white p-2 font-mono text-xs text-gray-700 whitespace-pre-wrap break-all">{{ row.outputJson ?? '–' }}</pre>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (hiddenTraceElements > 0) {
            <span class="text-xs text-gray-500" data-testid="rule-test-trace-more">+ {{ hiddenTraceElements }} weitere</span>
          }
        </div>
      }
    </div>
  }

  <!-- Rohausgabe (JSON) -->
  <div class="rounded-lg border border-gray-200 w-full" data-testid="rule-test-raw">
    <button (click)="rawOpen = !rawOpen"
            [attr.aria-expanded]="rawOpen"
            class="flex w-full items-center justify-between gap-2 px-4 py-3 text-left text-sm font-medium text-gray-900"
            type="button">
      <span>Rohausgabe anzeigen</span>
      <fa-icon [icon]="rawOpen ? faChevronUp : faChevronDown" class="text-gray-500"></fa-icon>
    </button>
    @if (rawOpen) {
      <div class="flex flex-col gap-2 border-t border-gray-200 px-4 py-3">
        <div class="flex justify-end">
          <bic-button (onClick)="copyRaw()" buttonType="white">
            <fa-icon iconLeft [icon]="faCopy"></fa-icon>
            Kopieren
          </bic-button>
        </div>
        <pre class="max-h-64 overflow-auto rounded bg-gray-50 p-3 font-mono text-xs text-gray-700 whitespace-pre-wrap break-all">{{ rawJson || '–' }}</pre>
      </div>
    }
  </div>
</div>
